import { PlaceChipModel } from '@/models/editor_modes/PlaceChipModel';
import type { IPlaceChipModel } from '@/interfaces/models';
import { TileManagerFactory } from '@/factories/TileManagerFactory';
import Context from '@/context';

export class ChipSelectModelFactory {
  constructor(private tileManagerModelFactory: TileManagerFactory) {}

  create(context: Context): IPlaceChipModel {
    const tileManagerModel = this.tileManagerModelFactory.create(context);
    return new PlaceChipModel(tileManagerModel, context);
  }
}
